/** Local storage failure must never trap someone in a shared-device session. */
export async function signOutWithMediaCheck(input: {
  hasMedia: () => Promise<boolean>;
  confirm: (storageUnavailable: boolean) => boolean;
  purge: () => Promise<void>;
  warn: () => void;
  finish: () => Promise<void>;
}): Promise<void> {
  let hasMedia = true;
  let unavailable = false;
  try {
    hasMedia = await input.hasMedia();
  } catch {
    unavailable = true;
  }
  if (hasMedia && !input.confirm(unavailable)) return;
  try {
    await input.purge();
  } catch {
    input.warn();
  }
  await input.finish();
}
